var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.309 14.981a6.784 6.784 0 005.018 5.082c2.1.509 4.304.509 6.405 0a6.784 6.784 0 005.018-5.082c.51-2.24.386-4.578-.358-6.752l-.11-.323a7.005 7.005 0 00-5.347-4.62",
    stroke: "#9495A0",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.364 3.636C6.364 2.733 7.096 2 8 2v0c.904 0 1.636.733 1.636 1.636v.546c0 1.205.977 2.182 2.182 2.182h.546C13.267 6.364 14 7.096 14 8v0c0 .904-.733 1.636-1.636 1.636h-.546a2.182 2.182 0 00-2.182 2.182v.546C9.636 13.267 8.904 14 8 14v0a1.636 1.636 0 01-1.636-1.636v-.546a2.182 2.182 0 00-2.182-2.182h-.546A1.636 1.636 0 012 8v0c0-.904.733-1.636 1.636-1.636h.546a2.182 2.182 0 002.182-2.182v-.546z",
    stroke: "#9495A0",
    strokeWidth: 1.3
  })));
}
export default SvgExperienceDetail;